import {
  Box,
  Button,
  Paper,
  Table,
  TextField,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Grid,
  InputLabel,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

const installement = [
  {
    sl: 1,
    policyNo: '4101241200000134-00',
    endorsementNo: '4501250010700197',
    dateOfTransaction: '07 Jan 2025',
    transactionMonth: 'Jan 2025',
    referenceType: 'Endorsement Change in DOB',
    referenceNo: '4501250010700197',
    particular: 'Endorsement invoice generate,Endorsement no : 4501250010700197',
    amountDebited: '0.00',
    amountCredited: '0.00',
    cdBalance: '12385925.50',
  },
  {
    sl: 1,
    policyNo: '4101241200000134-00',
    endorsementNo: '4501250010700121',
    dateOfTransaction: '08 Jan 2025',
    transactionMonth: 'Jan 2025',
    referenceType: 'Endorsement Change in DOB',
    referenceNo: '4501250010700121',
    particular: 'Endorsement invoice generate,Endorsement no : 4501250010700121',
    amountDebited: '0.00',
    amountCredited: '0.00',
    cdBalance: '12385925.50',
  },
  {
    sl: 1,
    policyNo: '4101241200000180-00',
    endorsementNo: '4501250010700147',
    dateOfTransaction: '24 Jan 2025',
    transactionMonth: 'Jan 2025',
    referenceType: 'Endorsement Change in DOB',
    referenceNo: '4501250010700147',
    particular: 'Endorsement invoice generate,Endorsement no : 4501250010700147',
    amountDebited: '0.00',
    amountCredited: '0.00',
    cdBalance: '17684410.43',
  },
  {
    sl: 1,
    policyNo: '4101241200000122-00',
    endorsementNo: '4501250010700138',
    dateOfTransaction: '07 Feb 2025',
    transactionMonth: 'Feb 2025',
    referenceType: 'Endorsement Change in DOB',
    referenceNo: '4501250010700138',
    particular: 'Endorsement invoice generate,Endorsement no : 4501250010700138',
    amountDebited: '0.00',
    amountCredited: '0.00',
    cdBalance: '609170.28',
  },
  {
    sl: 1,
    policyNo: '4101241200000138-00',
    endorsementNo: '4501250010700189',
    dateOfTransaction: '25 Mar 2025',
    transactionMonth: 'Mar 2025',
    referenceType: 'Endorsement Change in DOB',
    referenceNo: '4501250010700189',
    particular: 'Endorsement invoice generate,Endorsement no : 4501250010700189',
    amountDebited: '0.00',
    amountCredited: '0.00',
    cdBalance: '104084.98',
  },
];

const AccountStatement = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [formData, setFormData] = useState({
    corporate: '',
    rateChartType: '',
    policyType: '',
    tpaType: '',
    policyIssuanceType: '',
    // previousPolicy: '',
  });

  const handleFilter = () => {
    const filtered = installement.filter(row => {
      const policyDate = new Date(row.policyStartDate);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start && end) {
        return policyDate >= start && policyDate <= end;
      } else if (start) {
        return policyDate >= start;
      } else if (end) {
        return policyDate <= end;
      }
      return true;
    });

    setFilteredData(filtered);
  };

  const handleChange = field => event => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  useEffect(() => {
    // After data is fetched and setInstallement(installementData)
    setFilteredData(installement); // show all by default
  }, [installement]);
  return (
    <Box style={{ marginTop: '1rem' }}>
      <Box component={Paper} p={2} mb={2} fontWeight="bold">
        Account Statement
      </Box>
      <Box component={Paper} p={4} mb={3} mt={3}>
        <Grid container spacing={3}>
          {/* Insurance Company */}
          <Grid item xs={12} sm={6} style={{ display: 'flex', gap: '1rem' }}>
            <Typography variant="subtitle2" gutterBottom>
              Insurance Company :
            </Typography>
            <Typography variant="body1">SBI General Insurance Company Ltd</Typography>
          </Grid>

          {/* Receipt Type */}
          <Grid item xs={12} sm={6} style={{ display: 'flex', gap: '1rem' }}>
            <Typography variant="subtitle2" gutterBottom>
              Receipt Type :
            </Typography>
            <Typography variant="body1">CD</Typography>
          </Grid>
          <Grid container spacing={3} style={{ marginTop: '1rem' }}>
            {/* Corporate Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="corporate-label">Corporate</InputLabel>
                <Select
                  labelId="corporate-label"
                  label="Corporate"
                  value={formData.corporate}
                  onChange={handleChange('corporate')}
                  displayEmpty>
                  <MenuItem value="cordlife">CORDLIFE SCIENCES INDIA PRIVATE LIMITED</MenuItem>
                  <MenuItem value="standard">CORDLIFE SCIENCES INDIA PVT LTD</MenuItem>
                  <MenuItem value="standard">CORE ENERGY SYSTEMS PRIVATE LIMITED</MenuItem>
                  <MenuItem value="standard">CORMECHANICS PRIVATE LIMITED</MenuItem>
                  <MenuItem value="standard">COROT SYSTEMS PRIVATE LIMITED</MenuItem>
                  <MenuItem value="standard">CORPORATE ENTERPRISES</MenuItem>
                  <MenuItem value="standard">CORPORATE WARRANTIES INDIA PRIVATE LIMITED</MenuItem>
                  <MenuItem value="standard">CORPORATION BANK RETIRED OFFICERS ASSOCIATION</MenuItem>
                  <MenuItem value="standard">CORSICA SOLUTIONS PRIVATE LIMITED</MenuItem>
                  <MenuItem value="standard">MULTITECH CONCEPTS</MenuItem>
                  <MenuItem value="standard">MUNJAL SHOWA LTD</MenuItem>
                  <MenuItem value="standard">MUSIC BROADCAST LIMITED</MenuItem>
                  <MenuItem value="standard">MUTHOOT PAPPACHAN CENTRE OF EXCELLENCE IN SPORTS</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Receipt Date From */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Receipt Date From"
                type="date"
                size="small"
                fullWidth
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              />
            </Grid>

            {/* Receipt Date To */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Receipt Date To"
                type="date"
                size="small"
                fullWidth
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              />
            </Grid>
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} style={{ textAlign: 'right', marginTop: '1rem' }}>
            <Button variant="contained" color="primary" onClick={handleFilter}>
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Typography>Corporate Account No : C13184</Typography>
      <Box style={{ marginTop: '1rem' }}>
        <TableContainer component={Paper}>
          <Table>
            {' '}
            <TableHead style={{ backgroundColor: '#f5f5f5' }}>
              <TableRow>
                <TableCell>Sl#</TableCell>
                <TableCell>Policy No</TableCell>
                <TableCell>Endorsement No</TableCell>
                <TableCell>Date Of Transaction</TableCell>
                <TableCell>Transaction Month</TableCell>
                <TableCell>Reference Type</TableCell>
                <TableCell>Reference No</TableCell>
                <TableCell>Particular</TableCell>
                <TableCell>Amount Debited</TableCell>
                <TableCell>Amount Credited</TableCell>
                <TableCell>Balance In CD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData?.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.policyNo}</TableCell>
                  <TableCell>{row.endorsementNo}</TableCell>
                  <TableCell>{row.dateOfTransaction}</TableCell>
                  <TableCell>{row.transactionMonth}</TableCell>
                  <TableCell>{row.referenceType}</TableCell>
                  <TableCell>{row.referenceNo}</TableCell>
                  <TableCell>{row.particular}</TableCell>
                  <TableCell>{row.amountDebited}</TableCell>
                  <TableCell>{row.amountCredited}</TableCell>
                  <TableCell>{row.cdBalance}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default AccountStatement;
